
import { parsePhoneNumber } from 'awesome-phonenumber'

export function convertToE164Format(input) {
  const phone = parsePhoneNumber(input)
  return phone.number?.e164 || input
}
